import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { http, errorText } from "@/lib/api";
import { AdminTitle } from "./AdminLayout";

const Card = ({ item, onSaved, onDelete }) => {
  const [c, setC] = useState(item);
  const set = (k) => (e) => setC({ ...c, [k]: e.target.value });
  const save = async () => {
    try {
      const { id, updated_at, ...body } = c;
      await http.put(`/admin/courses/${id}`, body);
      toast.success("Kurs lagret");
      onSaved();
    } catch (e) { toast.error(errorText(e)); }
  };
  return (
    <div className="border border-[#E5E0D8] p-6 space-y-3" data-testid={`admin-course-${item.id}`}>
      <Input value={c.title} onChange={set("title")} className="rounded-none font-medium" data-testid={`course-title-${item.id}`} />
      <div className="grid grid-cols-3 gap-3">
        <Input value={c.level} placeholder="Nivå" onChange={set("level")} className="rounded-none" />
        <Input value={c.duration} placeholder="Varighet" onChange={set("duration")} className="rounded-none" />
        <Input value={c.price} placeholder="Pris (tom = Be om pristilbud)" onChange={set("price")} className="rounded-none" data-testid={`course-price-${item.id}`} />
      </div>
      <Textarea rows={3} value={c.description} onChange={set("description")} className="rounded-none" />
      <div className="flex items-center justify-between">
        <label className="flex items-center gap-2 text-sm"><Switch checked={c.published} onCheckedChange={(v) => setC({ ...c, published: v })} data-testid={`course-published-${item.id}`} />{c.published ? "Synlig på nettsiden" : "Skjult"}</label>
        <div className="flex gap-2">
          <button onClick={() => onDelete(item.id)} className="p-2 text-[#5C5A56] hover:text-red-700" data-testid={`course-delete-${item.id}`}><Trash2 className="w-4 h-4" strokeWidth={1.5} /></button>
          <button onClick={save} className="px-5 py-2 bg-[#1A1A1A] text-white text-sm" data-testid={`course-save-${item.id}`}>Lagre</button>
        </div>
      </div>
    </div>
  );
};

export default function CoursesAdmin() {
  const [items, setItems] = useState([]);
  const load = () => http.get("/admin/courses").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const add = async () => { await http.post("/admin/courses", { title: "Nytt kurs", published: false, order: items.length }); load(); };
  const remove = async (id) => { if (window.confirm("Slette kurset?")) { await http.delete(`/admin/courses/${id}`); load(); } };
  return (
    <div data-testid="admin-courses">
      <AdminTitle title="Sykurs" sub="Rediger kurs, nivå, varighet og pris. Skjulte kurs vises ikke på nettsiden og brukes ikke av AI-assistenten.">
        <button onClick={add} className="flex items-center gap-2 px-5 py-2.5 bg-[#1A1A1A] text-white text-sm" data-testid="course-add-btn"><Plus className="w-4 h-4" />Nytt kurs</button>
      </AdminTitle>
      <div className="grid xl:grid-cols-2 gap-6">
        {items.map((c) => <Card key={`${c.id}-${c.updated_at}`} item={c} onSaved={load} onDelete={remove} />)}
      </div>
    </div>
  );
}
